/** 교환·환불 기준 안내 — 사용자가 정한 문구(문의 설계 §8). 글자를 바꾸지 않는다. */
export const ORDER_INQUIRY_POLICY_INTRO =
  '상품 수령 후 7일 이내에 검수하시고, 이상이 있는 경우 해당 기간 내에 접수해 주세요. 기간이 지난 후에는 초기 불량 여부 확인이 어려울 수 있습니다.';
export const ORDER_INQUIRY_POLICY_RULES: readonly string[] = [
  '불량·오배송·수량 부족: 사진과 함께 접수해 주시면 확인 후 재제작 또는 환불해 드립니다.',
  '단순 변심, 사이즈·색상 차이(모니터 차이 포함): 주문 제작 상품이라 교환·환불이 어렵습니다.',
  '시안 확정 뒤 발견한 디자인 오류(오타 등): 고객 책임으로, 재제작은 유료입니다.',
];
